import { SxStyles } from '../../../../../../../types';
import theme from '../../../../../../../theme';
import { getResponsiveSize } from '../../../../../../../utils';

export const FileUploadStyle: SxStyles = {
  fileUploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '70%',
    border: '3px dashed',
    borderColor: theme.palette.myPrimary?.lightBlue70,
    gap: getResponsiveSize(12),
    py: getResponsiveSize(32),
    px: getResponsiveSize(12),
    mb: getResponsiveSize(15),
    position: 'relative',
    '& .drop-zone': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      '& .MuiTypography-root': {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '100%',
        fontWeight: '400',
        textAlign: 'center',
        p: getResponsiveSize(4),
        color: theme.palette.neutral?.grey70,
        fontFamily: theme.typography.mainFontFamily,
        fontSize: getResponsiveSize(17),
      },
    },
    '& .snack-bar': {
      '& .alert': {
        fontSize: getResponsiveSize(12),
      },
    },
  },
  dialog: {
    '& .MuiPaper-root': {
      borderRadius: '20px',
      '& .MuiDialogTitle-root': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: theme.palette.neutral?.grey8,
        color: theme.palette.mainControls?.activeText,
        fontFamily: theme.typography.fontFamily,
        fontSize: getResponsiveSize(14),
      },
      '& .MuiDialogContent-root': {
        '& .empty': {
          borderColor: 'red',
        },

        '& .MuiFormControl-root': {
          '& .MuiInputBase-root': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.neutral?.grey50,
              borderRadius: '12px',
            },
            '&:hover fieldset': {
              borderColor: theme.palette.myPrimary?.lightBlue70,
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.myPrimary?.lightBlue70,
            },
            '& .MuiInputBase-input': {
              p: getResponsiveSize(8),
            },
          },
        },
      },
      '& .MuiDialogActions-root': {
        display: 'flex',
        alignItems: 'center',
        '& .confirm-btn': {
          p: getResponsiveSize(8),
          height: getResponsiveSize(28),
          fontSize: getResponsiveSize(12),
          backgroundColor: '#65B3CF',
          lineHeight: 0,
        },
        '& .cancel-btn': {
          p: getResponsiveSize(8),
          height: getResponsiveSize(28),
          fontSize: getResponsiveSize(12),
          color: '#65B3CF',
          borderColor: '#65B3CF',
          lineHeight: 0,
        },
      },
    },
  },
};
